import React from 'react';

import { IIconProps } from 'ui/CircleIconButton';
import { theme } from '../../../../../../tailwind.config';

export const CrmActivityMeeting: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['white'], background = theme.colors['status-requested'] }) => (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill={background}/>
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke={background}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M15 19.1667C13.6167 19.1667 12.5083 18.05 12.5083 16.6667C12.5083 15.2834 13.6167 14.1667 15 14.1667C15.2667 14.1667 15.525 14.2084 15.7583 14.2834C15.2833 14.9584 15.0083 15.775 15.0083 16.6667C15.0083 17.5584 15.2917 18.3667 15.7583 19.05C15.525 19.125 15.2667 19.1667 15 19.1667ZM23.3333 18.3334H25.8333V15.8334H27.5V18.3334H30V20H27.5V22.5H25.8333V20H23.3333V18.3334ZM16.675 16.6667C16.675 18.05 17.7833 19.1667 19.1667 19.1667C20.55 19.1667 21.6667 18.05 21.6667 16.6667C21.6667 15.2834 20.55 14.1667 19.1667 14.1667C17.7833 14.1667 16.675 15.2834 16.675 16.6667ZM13.65 20.9667C12.9583 21.575 12.5 22.35 12.5 23.3334V25H10V23.3334C10 22.05 11.975 21.2584 13.65 20.9667ZM24.1667 23.3334C24.1667 21.6667 20.8333 20.8334 19.1667 20.8334C17.5 20.8334 14.1667 21.6667 14.1667 23.3334V25H24.1667V23.3334Z" fill={fill} />
    </svg>
  )
);
